module.exports = __webpack_public_path__ + "static/media/other.d920640d.png";